import CRUDReducer from './crud_resourceful_reducer';
import ReadOnlyReducer from './readonly_resourceful_reducer';

export const CRUDResourcefulReducer = CRUDReducer;
export const ReadonlyResourcefulReducer = ReadOnlyReducer;

const ResourcefulReducer = ReadOnlyReducer;
export default ResourcefulReducer;
